import MaintenanceDetailsContainer from './MaintenanceListDetails.container';
export default MaintenanceDetailsContainer;
